export default __webpack_public_path__ + "static/media/bg-corner.b18d50ce.png";